import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { CustactGet, CustactService, GetCustactParams } from '@app/services/custact.service';

@Component({
    selector: 'tt-work-details',
    templateUrl: './work-details.component.html',
    styleUrls: ['./work-details.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkDetailsComponent implements OnInit {
    @Input()
    public params?: GetCustactParams;

    public get?: CustactGet;

    constructor(
        private custact: CustactService,
        private cdr: ChangeDetectorRef,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) public navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async loadGet() {
        if (!!this.params && typeof this.params === 'object' && 'custact_no' in this.params && !isNaN(+this.params.custact_no)) {
            this.get = await this.custact.getCustact(this.params);
            this.navigator?.setHeading?.(this.get.note);
            this.cdr.markForCheck();
            this.cdr.detectChanges();
        }
    }

    public markForChange() {
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        setTimeout(() => {
            this.cdr.markForCheck();
            this.cdr.detectChanges();
        });
    }

    private async init() {
        await this.loadGet();
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator?.setSize?.({ width: '98vw', height: '95vh' });
            this.params = this.navigator.params as any;
            this.init();
        }
    }
}
